export enum AppView {
    Activity, AroundMe, Events, Favorites, Buildings, Settings, Dashboard,
}